import { Box, Card, InputLabel, LinearProgress, makeStyles, TextField, Typography } from "@material-ui/core";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getImageDimensions } from "../../../utilities/common";
import TimeoutButton from "../../Common/TimeoutButton";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import ReactImageMagnify from 'react-image-magnify';
import { useDispatch } from "react-redux";
import { showAlertSnackbar } from "../../../reducers/uiSlice";
import {useDropzone} from 'react-dropzone';
import SlideShow from '../DriverApplicationsModal/SlideShow';

const useStyles = makeStyles((theme) => ({
    photo: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around'
    },
    dropContent: {
        marginLeft: 'auto', 
        marginRight: 'auto', 
        textAlign: 'center'
    },
    progressStyle: {
        color: theme.palette.warning.main
    },
    browseStyle: {
        color: theme.palette.warning.main, 
        cursor: 'pointer', 
        marginLeft: theme.spacing(1)
    },
    uploadingStyle: {
        color: theme.palette.text.primary
    }
}))

function DocFile(props) {
    const classes = useStyles();
    const {t} = useTranslation('driverApproval');
    const dispatch = useDispatch();

    const [docFile, setDocFile] = useState();
    const [files, setFiles] = useState([]);
    const [slideOpen, setSlideOpen] = useState(false);

    const onDrop = useCallback(acceptedFiles => {
        // Do something with the files
        setFiles(acceptedFiles.map(file => Object.assign(file, {
            preview: URL.createObjectURL(file)
          })));
      }, [])
      
    const {isDragActive, getRootProps, getInputProps} = useDropzone({onDrop, multiple: false})

    function handleOpenSlide() {
        setSlideOpen(true);
    }
    function handleSlideClose() {
        setSlideOpen(false);
    }
    function deleteCache(index) {
        props.handleDocument('delete', index);
    }

    useEffect(() => {
        if(props.document) {
            if(props.document.access_url) {
                setDocFile(props.document.access_url);
            } else if(props.document.preview) {
                setDocFile(props.document.preview);
            } else {
                setDocFile('');
            }
        }
    }, [props.document])
    useEffect(() => {
        if(files) {
            if(files.length > 0) {
                if(files[0].size > 2e+6) {
                    dispatch((showAlertSnackbar({message: t('more_than_two'), type:'error'})))
                    setFiles([]);
                } else {
                    props.handleDocument('upload', props.index, files[0]); 
                }
            }
            
        }
    }, [files])

    return (
        <div>
            <div className={classes.photo}>
                {
                    docFile ?
                    <img
                        src={docFile}
                        style={{
                            width: 320,
                            height: 200,
                            zIndex: 1000,
                            borderRadius: 4,
                            cursor: 'pointer'
                        }}
                        onClick={handleOpenSlide}
                    />
                    :
                    <div {...getRootProps()} >
                        <div style={{width: '100%', textAlign: 'center', marginTop: 48, marginBottom: 14}}>
                            <img 
                                src={'/images/icons/pic.svg'}
                                style={{width: 49, height: 36}}
                            />
                        </div>
                        {
                            isDragActive ?
                            <div>Drop the files here ...</div> :
                            <div style={{width: '100%',  fontSize: 14}}>
                                <div className={classes.dropContent}>
                                    Drop your image here, 
                                </div>
                                <div className={classes.dropContent}>
                                    or 
                                    <span className={classes.browseStyle}>
                                        browse
                                    </span>
                                </div>
                            </div>
                        }
                        <input 
                            style={{height: 200}}
                            {...getInputProps()} 
                        />
                    </div>
                }
            </div>
            <SlideShow open={slideOpen} slideImages={props.documentUploadList} handleClose={handleSlideClose} indexSlide={props.index} accountId={props.accountId} deleteCache={deleteCache}/>
        </div>
    )
}

export default DocFile;